import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { BankOperationsList } from './BankOperationsList/BankOperationsList';
import { BankOperationsShow } from './BankOperationsShow/BankOperationsShow';

export const bankOperationsResource: ResourceProps = {
  name: Resources.BankOperations,
  list: BankOperationsList,
  show: BankOperationsShow,
  create: <></>,
  edit: <></>,
};
